/**
 * Pure render-mode helpers for a package step (PackageRunView).
 *
 * A package step honours the member form's ai_mode exactly like a single
 * assigned/public form: 'form_only' opens the manual Form.io view, while every
 * AI-capable mode ('ai_only', 'toggle') opens the AI intake chat. Only 'toggle'
 * offers the patient a Chat/Manual switch. Kept in a plain .ts module (no React)
 * so the branching is unit-testable under the node-env vitest setup and stays in
 * lockstep with AssignedFormView.
 */

export type StepMode = 'ai' | 'manual';

/** Initial render mode for a step from its form's ai_mode. */
export function resolveStepMode(aiMode: string): StepMode {
  return aiMode === 'form_only' ? 'manual' : 'ai';
}

/** Only 'toggle' steps expose the Chat/Manual switch. */
export function stepAllowsToggle(aiMode: string): boolean {
  return aiMode === 'toggle';
}
